<script setup lang="ts">
import { Link, usePage } from "@inertiajs/vue3"
import { ChevronDownIcon, UserCircleIcon } from "@heroicons/vue/24/outline"
import { computed, ref } from "vue"

type PageProps = {
  auth?: {
    user?: {
      name?: string
      email?: string
    }
    current_company?: {
      settings_path?: string
    } | null
  }
}

const page = usePage<PageProps>()
const isOpen = ref(false)

const userName = computed(() => page.props.auth?.user?.name ?? "Usuario")
const userEmail = computed(() => page.props.auth?.user?.email ?? "")
const initials = computed(() => {
  return userName.value
    .split(" ")
    .map((part) => part[0])
    .join("")
    .slice(0, 2)
    .toUpperCase()
})
const companySettingsPath = computed(() => page.props.auth?.current_company?.settings_path || "")

function toggleMenu() {
  isOpen.value = !isOpen.value
}
</script>

<template>
  <div class="relative">
    <button
      type="button"
      class="flex items-center gap-2 rounded-full border border-slate-200 bg-white px-2 py-1 text-sm text-slate-700 transition hover:bg-slate-50"
      @click="toggleMenu"
    >
      <span class="inline-flex size-8 items-center justify-center rounded-full bg-slate-900 text-xs font-semibold text-white">
        {{ initials }}
      </span>
      <span class="hidden text-sm font-medium md:block">{{ userName }}</span>
      <ChevronDownIcon class="size-4 text-slate-500" />
    </button>

    <div
      v-if="isOpen"
      class="absolute right-0 mt-2 w-56 rounded-lg border border-slate-200 bg-white p-2 shadow-lg"
    >
      <div class="rounded-md bg-slate-50 p-3">
        <div class="flex items-center gap-2">
          <UserCircleIcon class="size-5 text-slate-500" />
          <p class="text-sm font-medium text-slate-800">{{ userName }}</p>
        </div>
        <p class="mt-1 truncate text-xs text-slate-500">{{ userEmail }}</p>
      </div>

      <Link
        v-if="companySettingsPath"
        :href="companySettingsPath"
        class="mt-2 block w-full rounded-md px-3 py-2 text-left text-sm text-slate-700 transition hover:bg-slate-100"
      >
        Minha empresa
      </Link>

      <Link
        href="/users/sign_out"
        method="delete"
        as="button"
        class="mt-2 w-full rounded-md px-3 py-2 text-left text-sm text-red-600 transition hover:bg-red-50"
      >
        Sair
      </Link>
    </div>
  </div>
</template>

